import React from 'react';
import { useTranslation } from 'react-i18next';
import classNames from 'classnames';
import infoIcon from 'Assets/layout/profile/services-info.svg';

import './ServiceInfoButton.scss';

interface ServiceInfoButtonProps {
  /**
   * `emphasised` pins the brand-blue glyph at the end of a category header; `muted` sits
   * inline after a service/detail label. The same control and behavior — placement and tone differ.
   */
  treatment?: 'emphasised' | 'muted';
  onClick(): void;
}

/**
 * The ⓘ affordance that opens a node's {@link ServiceInfoModal}. Rendered only where the
 * payload carries info copy for that node, so it never opens an empty modal.
 */
export const ServiceInfoButton = ({ treatment = 'emphasised', onClick }: ServiceInfoButtonProps) => {
  const { t } = useTranslation();

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    // Sits on a clickable row — opening the modal must not also book the service
    event.stopPropagation();
    onClick();
  };

  return (
    <button
      type="button"
      styleName={classNames('service-info-button', `service-info-button--${treatment}`)}
      aria-label={t('T.PROS-PROFILE.SERVICES.INFO-ARIA')}
      onClick={handleClick}
    >
      <img src={infoIcon} alt="" aria-hidden="true" styleName="service-info-button__icon" />
    </button>
  );
};

export default ServiceInfoButton;
